import { request } from "../../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/login`;

class LoginService {
  async getLoginUserData(data) {
    try {
      let action = API_ROUTE + `/loginuser`;
      const response = await request.post(action, data);
      return response;
    } catch (error) {
      console.error("Errorin getTeams:", error);
      throw error;
    }
  }

  async forgotPasswordByUserID(data) {
    try {
      let action = API_ROUTE + `/update-newpassword-byid`;
      const response = await request.post(action, data);
      return response;
    } catch (error) {
      console.error("Errorin getTeams:", error);
      throw error;
    }
  }
  async updateUserLocation(data) {
    try {
      const action = API_ROUTE + `/update-location`;
      const response = await request.post(action, data);
      return response;
    } catch (error) {
      console.error("Error updating location:", error);
      throw error;
    }
  }

}

export default LoginService;
